import React from 'react';
import { Switch, Route } from 'react-router';
import moment from 'moment';
import ruLocale from 'moment/locale/ru';
import * as scenes from 'scenes';

moment.locale = ruLocale;

const App = () => (
	<div>
		<Switch>
			<Route path="/" component={scenes.HomeScene} />
		</Switch>
	</div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js